import ServerMasterList from './servermaster/ServerMasterList';
import ServerMasterWrite from './servermaster/ServerMasterWrite';
import { isNotDefined, namespace } from '../utils/util';
import { API_DOMAIN_DEFAULT } from '../model/model';
import Utils from "./config/Util";
import ServerWrite from "./server/write/ServerWrite";

(function ($, global) {
  "use strict";

  namespace('nc.lineage');
  const _device = window._device;
  const isServerMasterBoard = Utils.ServerMasterBoard;
  const serverAlias = Utils.getServerAlias;

  console.log( 'servermaster.js isServerMasterBoard : ', isServerMasterBoard);

  nc.lineage.serverMasterList = function (_board,options) {
    console.log('servermaster.js  serverMasterList function _board : ', _board);
    if (isNotDefined(options)) throw new Error('nc.lineage.boardServerList constructor require options object');
    let option = $.extend(true, {
      wrap: $('#ncCommunityList'),
      apiDomain: window._communityApiPath,
      hostApiDomain: window._apiPath, // api-lineage
      isNCommunity: true,
      ncCommunityList: _board,
      isShowServerMasterArticles: true,
      serverAlias: options.serverAlias,
      device: _device,
      isIngame: false,
      global: global
    }, options);
    return new ServerMasterList(option).init();
  };


  // write
  const _checkServerMasterWrite = function(data){
    console.log('onHookSubmitBefore(data) : ', ServerMasterWrite);
    console.log('onHookSubmitBefore(data) : ', data);
    if(ServerMasterWrite) ServerMasterWrite.submitWriteData(data); // => call serverWrite.onSubmit(changedData) after change data
  };


  nc.lineage.serverMasterWrite = function (_board,options) {
    console.log('servermaster.js  serverMasterWrite function _board : ', _board);
    if (isNotDefined(options)) throw new Error('nc.lineage.serverMasterWrite constructor require options object');
    let option = $.extend(true, {
      wrap: $('#ncCommunityWrite'),
      apiDomain: window._communityApiPath,
      hostApiDomain: window._apiPath, // api-lineage
      isNCommunity: true,
      ncCommunityWrite: _board,
      isShowServerMasterArticles: true,
      device: _device,
      isIngame: false,
      serverAlias: options.serverAlias,
      writeData: options.writeData,
      global: global
    }, options);
    return new ServerMasterWrite(option).init();
  };



}(jQuery, window));


// WEBPACK FOOTER //
// ./_src/js/board/servermaster.js